import React from "react";
import { Box, Typography } from "@mui/material";
import styles from "./PredefinedPrompts.module.scss";
import { getAgentPromptTitle } from "../../utils/helper";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

export interface Prompt {
  prompt: string;
  title: string;
  templateFileName?: string;
}

interface PredefinedPromptsProps {
  prompts: Prompt[];
  onPromptClick: (prompt: string, templateFileName?: string) => void;
  isSmallChatWindow?: boolean; // true for small chat window, false/undefined for chat modal
}

const PredefinedPrompts: React.FC<PredefinedPromptsProps> = ({
  prompts,
  onPromptClick,
  isSmallChatWindow = false,
}) => {
  const currentAgent = useSelector(
    (state: RootState) => state.agents.currentAgent
  );
  const agentId = currentAgent?.id.toString();
  const mainTitle = getAgentPromptTitle(agentId);

  return (
    <Box
      className={`${styles.predefinedPromptsContainer} ${isSmallChatWindow ? styles.smallChatWindow : styles.chatModal}`}
    >
      <Typography
        variant="h2"
        className={`${styles.mainTitle}${agentId === "20" ? ` ${styles.mainTitleSubtle}` : ""}`}
      >
        {mainTitle}
      </Typography>
      <Box className={styles.promptsGrid}>
        {prompts.map((prompt, idx) => (
          <Box
            key={idx}
            className={styles.promptCard}
            onClick={() =>
              onPromptClick(prompt.prompt, prompt.templateFileName)
            }
          >
            <Typography className={styles.promptTitle}>
              {prompt.title}
            </Typography>
            <Typography className={styles.promptDescription}>
              {prompt.prompt}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PredefinedPrompts;
